module.exports = __webpack_public_path__ + "img/tip-drinks.763913f1.png";